var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('load-history-searcher')],1)],1),_c('b-row',[_c('b-col',[_c('load-history-exporter')],1)],1),_c('b-row',[_c('b-col',[_c('load-history-search-result')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }